import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Maison Aveline',
    description: "Handbags, fine jewelry and gloves, made by hand in Paris since 1908. Discover the Autumn–Winter 2026 collection and apply to Le Cercle, the house's private membership.",
    url: getOrigin()
}
